import { CookieAttributes } from 'js-cookie'

/** Delay (in milliseconds) to debounce when typing a text search. */
export const DELAY_DEBOUNCE = 800

/** Size limit to load more data. */
export const PAGINATION_BOTTOM = 250

export const PAGINATION_LIMIT = 40

// Cookies
const COOKIE_OPTIONS: CookieAttributes = {
    expires: 365 * 2, // 2 years
    path: '/',
    sameSite: 'strict',
}

const COOKIE_OPTIONS_CART: CookieAttributes = {
    ...COOKIE_OPTIONS,
    expires: 2 / 24, // 2 hour
}

export const cookies = {
    tokens: {
        ACCESS_TOKEN: 'access_token',
        OPTIONS: COOKIE_OPTIONS,
        REFRESH_TOKEN: 'refresh_token',
    },

    cart: {
        CART: 'cart',
        OPTIONS: COOKIE_OPTIONS_CART,
    },
}

export const links = {
    E_THIK: 'https://www.e-thik.com',
}

/** Make a pause with the time given (in milliseconds). */
export const pause = async (time: number) => {
    await new Promise((resolve) => {
        setTimeout(resolve, time)
    })
}

export const DRAWER_WIDTH = 260
export const GRID_SPACING = 3

export const ID_MANAGER_FREEGO = 19
